import { Button, Form, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useNavigation, useSubmit } from "react-router";
import FormPage from "../common/FormPage";
import { requiredField } from "../common/common";
import PosModelFields from "./PosModelFields";

export default function NewPosModel() {
  const submit = useSubmit();
  const navigation = useNavigation();
  const onFinish = (form) => {
    const data = new FormData();
    data.append("file", form.file[0].originFileObj);
    const payload = {
      name: form.name,
      formItems: form.formItems ?? [],
      sections: form.sections ?? [],
    };
    data.append("payload", new Blob([JSON.stringify(payload)], { type: "application/json" }));
    submit(data, { method: "post", encType: "multipart/form-data" });
  };
  return (
    <FormPage
      title="Nuovo modello POS"
      onFinish={onFinish}
      initialValues={{ formItems: [], sections: [] }}
    >
      <PosModelFields />
      <Form.Item
        label="Modello Word"
        name="file"
        valuePropName="fileList"
        getValueFromEvent={(event) => event.fileList}
        rules={[{ ...requiredField, type: "array", min: 1 }]}
      >
        <Upload.Dragger accept=".docx" maxCount={1} beforeUpload={() => false}>
          <p>Trascina qui il modello Word (.docx)</p>
          <Button icon={<UploadOutlined />}>Seleziona file</Button>
        </Upload.Dragger>
      </Form.Item>
      <Form.Item style={{ textAlign: "end" }} wrapperCol={{ span: 24 }}>
        <Button type="primary" htmlType="submit" loading={navigation.state === "submitting"}>
          Conferma
        </Button>
      </Form.Item>
    </FormPage>
  );
}
